import { c as _c } from "react/compiler-runtime";
import { Fragment, ReactNode } from 'react';

/**
 * Joins an array of React nodes with a specified separator.
 */
export const JoinNodes = t0 => {
  const $ = _c(8);
  const {
    elements,
    separator
  } = t0;
  let t1;
  if ($[0] !== elements || $[1] !== separator) {
    let t2;
    if ($[3] !== elements.length || $[4] !== separator) {
      t2 = (element, index) => <Fragment key={index}>{element}{index < elements.length - 1 && separator}</Fragment>;
      $[3] = elements.length;
      $[4] = separator;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    t1 = elements.map(t2);
    $[0] = elements;
    $[1] = separator;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = <>{t1}</>;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};